import { FC, ReactElement, ReactNode } from 'react';
import { NavLink as BaseLink } from 'react-router-dom';

import { StyleProps, Text } from '@bonusly/design-system';

import { CountBadge } from '../../../../components/badge/count-badge';
import { useIsRecognize } from '../../../../hooks/use-is-recognize';
import { ColorScheme, IconChip } from '../Chip';
import { DropdownOption } from '../Dropdown';

interface Props extends StyleProps {
	badgeCount?: number;
	children: ReactNode;
	colorScheme?: ColorScheme;
	icon: ReactElement;
	onClick?: VoidFunction;
	to: string;
}

export const NavMenuLink: FC<Props> = ({ badgeCount, children, colorScheme, icon, onClick, to, ...rest }) => {
	const isRecognize = useIsRecognize();
	return (
		<DropdownOption p={2} variant="floating" {...rest}>
			<BaseLink reloadDocument={isRecognize} style={{ display: 'flex', alignItems: 'center' }} data-testid="nav-menu-link" onClick={onClick} to={to}>
				<CountBadge count={badgeCount}>
					<IconChip colorScheme={colorScheme}>{icon}</IconChip>
				</CountBadge>

				<Text as="span" color="gray.700" ml={3} fontSize="md">
					{children}
				</Text>
			</BaseLink>
		</DropdownOption>
	);
};
